// Generated by purs version 0.15.0
import * as Data_Date from "../Data.Date/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Time_Local from "../Data.Time.Local/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Restaumatic_Calendar_Types_Availability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Restaumatic_Menu_V2_Types_MenuConsumer from "../Restaumatic.Menu.V2.Types.MenuConsumer/index.js";
import * as Restaumatic_Promotions_Types from "../Restaumatic.Promotions.Types/index.js";
import * as Restaumatic_Promotions_Types_Id from "../Restaumatic.Promotions.Types.Id/index.js";
import * as Restaumatic_PromotionsEngine_Cart_PromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Promotion/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var withPromotionId = function (v) {
    return new Data_Tuple.Tuple(v.promotionId, v);
};
var toPromotionType = function (v) {
    if (v instanceof Restaumatic_Promotions_Types.Standard) {
        return Restaumatic_PromotionsEngine_Promotions_Promotion.Standard.value;
    };
    if (v instanceof Restaumatic_Promotions_Types.InformationOnly) {
        return Restaumatic_PromotionsEngine_Promotions_Promotion.InformationOnly.value;
    };
    if (v instanceof Restaumatic_Promotions_Types.RequiresCoupon) {
        return Restaumatic_PromotionsEngine_Promotions_Promotion.RequiresCoupon.value;
    };
    throw new Error("Failed pattern match at Restaumatic.Menu.Promotions (line 55, column 1 - line 55, column 60): " + [ v.constructor.name ]);
};
var toEnginePromotion = function (p) {
    return {
        promotionId: Data_Newtype.unwrap()(Data_Record.getField(Restaumatic_Promotions_Types.hasFieldPromotion(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "promotionId";
            }
        })()))(Type_Proxy["Proxy"].value)(p)),
        promotionType: toPromotionType(Data_Record.getField(Restaumatic_Promotions_Types.hasFieldPromotion(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "promotionType";
            }
        })()))(Type_Proxy["Proxy"].value)(p)),
        conditions: Data_Record.getField(Restaumatic_Promotions_Types.hasFieldPromotion(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "conditions";
            }
        })()))(Type_Proxy["Proxy"].value)(p),
        prize: Data_Record.getField(Restaumatic_Promotions_Types.hasFieldPromotion(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "prize";
            }
        })()))(Type_Proxy["Proxy"].value)(p),
        combineTo: Data_Record.getField(Restaumatic_Promotions_Types.hasFieldPromotion(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "combineTo";
            }
        })()))(Type_Proxy["Proxy"].value)(p),
        autoAssignable: Data_Record.getField(Restaumatic_Promotions_Types.hasFieldPromotion(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "enableAutoselect";
            }
        })()))(Type_Proxy["Proxy"].value)(p)
    };
};
var isCouponPromotion = function (v) {
    return Data_Eq.eq(Restaumatic_Promotions_Types.eqPromotionType)(v.promotionType)(Restaumatic_Promotions_Types.RequiresCoupon.value);
};
var isAvailableAt = function (localDateTime) {
    return function (consumers) {
        return function (v) {
            return Restaumatic_Calendar_Types_Availability.isAvailable(v.availability)(localDateTime) && (Data_Ord.greaterThanOrEq(Data_Date.ordDate)(Data_Time_Local.localDate(localDateTime))(Data_Newtype.unwrap()(v.start)) && (Data_Ord.lessThanOrEq(Data_Date.ordDate)(Data_Time_Local.localDate(localDateTime))(Data_Newtype.unwrap()(v.finish)) && !Data_Set.isEmpty(Data_Set.intersection(Restaumatic_Menu_V2_Types_MenuConsumer.ordMenuConsumer)(Data_Newtype.unwrap()(v.enabledMenuConsumers))(consumers))));
        };
    };
};
export {
    toEnginePromotion,
    isAvailableAt,
    withPromotionId,
    isCouponPromotion
};
export {
    Promotion,
    InformationOnly,
    RequiresCoupon,
    Standard
} from "../Restaumatic.Promotions.Types/index.js";
export {
    PromotionId
} from "../Restaumatic.Promotions.Types.Id/index.js";
export {
    Percentage,
    Price
} from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
//# sourceMappingURL=index.js.map
